// a hook using use-swr to fetch favorite games
import { GameService } from "src/service/GameService";
import { AppsData } from "data/AppsData";
import useSWR from "swr";
import useAuthContext from "src/contexts/AuthContext";
import { mangaQuizGame } from "data/manga-quiz";

const allGames = [...AppsData];
allGames.push(mangaQuizGame);
export function useFavoriteGames() {
  const { authUser } = useAuthContext();
  const { data, error, isLoading, mutate } = useSWR(
    authUser ? authUser?.userId + "favorite-games" : null,
    GameService.FavoriteGamesList,
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
    }
  );
  // This logic will be moved once the game data is fetched from the backend
  const gameData = data?.map(game => {
    return allGames.find(g => g.game_id === game.gameId);
  });

  return {
    data: gameData,
    error,
    mutate,
    isLoading,
  };
}
